import React from 'react'

import { HouseNightlyTripIndividualSeasonalPricesFields } from './components/seasonal-prices-fields/HouseNightlyTripIndividualSeasonalPricesFields'
import { HouseNightlyTripIndividualTouristTaxField } from './components/tourist-tax/HouseNightlyTripIndividualTouristTaxField'
import { HouseNightlyTripIndividualVatField } from './components/vat-fields/HouseNightlyTripIndividualVatField'
import { HouseNightlyTripIndividualFieldProps } from '../form-container/HouseNightlyTripIndividualFormContainer'
import { Divider } from '../../../../../../../atoms/divider/Divider'

export const HouseNightlyTripIndividualOptionsFields = ({
  currencyArea,
  ...fieldProps
}: HouseNightlyTripIndividualFieldProps) => {
  return (
    <>
      <Divider />

      <HouseNightlyTripIndividualSeasonalPricesFields
        {...fieldProps}
        currencyArea={currencyArea}
      />

      <Divider />

      <HouseNightlyTripIndividualVatField
        {...fieldProps}
        currencyArea={currencyArea}
      />

      <Divider />

      <HouseNightlyTripIndividualTouristTaxField
        {...fieldProps}
        currencyArea={currencyArea}
      />
    </>
  )
}
